import React from 'react';
import { connect } from 'react-redux';

import axios from 'axios';
import { Modal } from 'react-bootstrap';
import { Table } from 'antd';
import Select from 'react-select';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

import {
  obterFormandosPeloContrato,
  editarFormando,
  editarFormandoEUsuario,
  deletarFormandoEUsuario,
} from '../actions/FormandoActions';
import { adicionarUsuarioFormando } from '../actions/UsuarioActions';
import { adicionarTurma, removerTurma } from '../actions/TurmaActions';
import { editarCamposContrato } from '../actions/ContratoActions';
import { URL_MAPA, URL_PAGAMENTO } from '../config/urls';
import EmailServices from '../services/email';
import TabelaPedidosFormando from './pedidosFormando/TabelaPedidosFormando';

// Exportada tambem sem o connect, para os testes.
export class DetalhesFormando extends React.Component {
  state = {
    selecionado: {},
    showModal: false,
    showModalFormando: false,
    showModalTurmas: false,
    showSelectTurmas: false,
    showModalPedidosFormando: false,
    formando: {},
    pedidosFormando: [],
    formandos: [],
    cursosSelect: [],
    todosOsCursos: [],
    cursoSelecionado: {},
    informarNomeTurmaManual: false,
    turmaSelecionada: {},
    nomeNovaTurma: '',
    deletandoFormando: false,
    gerandoLogins: false,
    reenviandoTodos: false,
    reenvio: null,
  };

  open() {
    let cursosSelect = [];
    this.props.selecionado.turmas.forEach((turma) =>
      cursosSelect.push({ value: turma.id, label: turma.curso })
    );
    this.setState(
      { cursosSelect, showModal: true, selecionado: this.props.selecionado, reenvio: this.state.reenviandoTodos ? this.state.reenvio : null },
      () => {
        this.carregarInfoContrato(this.state.selecionado.id);
      }
    );
  }

  close() {
    this.props.atualizarContrato({
      id: this.state.selecionado.id,
      turmas: this.state.cursosSelect,
      cadastrouFormandos: this.state.selecionado.cadastrouFormandos,
    });
    this.setState({ showModal: false });
  }

  async carregarInfoContrato(idContrato) {
    let formandos = [];

    await this.props.obterFormandosPeloContrato(idContrato);

    if (this.props.formandos.length > 0) {
      this.props.formandos.forEach((formando) =>
        formandos.push({
          id: formando.id,
          nome: formando.nome,
          email: formando.email,
          celular: formando.celular,
          documento: formando.documento,
          dataNascimento: formando.dataNascimento,
          turma: formando.formandos ? formando.formandos.id : '',
          curso: formando.formandos ? formando.formandos.curso : '',
          usuario: formando.usuario,
        })
      );
    }

    this.setState({ formandos, showModalFormando: false });
  }

  dadosDoAcesso = (formando) => ({
    usuario: {
      nome: formando.nome,
      email: formando.usuario.email,
      senha: formando.usuario.senha,
    },
  });

  enviarEmail = (formando) => {
    let button = document.querySelector(`#btnEnviarEmail${formando.id}`);

    button.innerHTML = "<i class='fa fa-spinner fa-spin'></i>";

    new EmailServices()
      .enviar('formando', this.dadosDoAcesso(formando))
      .then((response) => {
        this.atualizarTextoBotao(response, button, {
          sucesso: "<i class='fa fa-check'></i>",
          erro: "<i class='fa fa-times'></i>",
          resetar: "<i class='fa fa-envelope'></i>",
        });
      });
  };

  // Reenvia o e-mail de acesso para todos os formandos com login, um de cada
  // vez (o mesmo envio do envelope de cada linha), mostrando o andamento.
  reenviarParaTodos = async () => {
    const comLogin = this.state.formandos.filter((f) => f.usuario);
    if (!comLogin.length || this.state.reenviandoTodos) return;
    if (!window.confirm(`Reenviar o e-mail de acesso para ${comLogin.length === 1 ? 'o formando' : `os ${comLogin.length} formandos`} com login?`)) return;

    const falharam = [];
    this.setState({ reenviandoTodos: true, reenvio: { feitos: 0, total: comLogin.length, falharam } });

    for (let i = 0; i < comLogin.length; i++) {
      const enviado = await new EmailServices().enviar('formando', this.dadosDoAcesso(comLogin[i]), false);
      if (!enviado) falharam.push(comLogin[i].nome);
      this.setState({ reenvio: { feitos: i + 1, total: comLogin.length, falharam: falharam.slice() } });
    }

    this.setState({ reenviandoTodos: false });
  };

  _renderResultadoReenvio() {
    const { reenvio, reenviandoTodos } = this.state;
    if (!reenvio || reenviandoTodos) return null;
    const enviados = reenvio.total - reenvio.falharam.length;
    return (
      <span style={{ marginRight: 'auto', fontSize: 13, color: reenvio.falharam.length ? '#dd4b39' : '#00a65a' }}>
        <i className={`fa ${reenvio.falharam.length ? 'fa-exclamation-triangle' : 'fa-check'}`} style={{ marginRight: 5 }} />
        E-mail de acesso reenviado para {enviados} de {reenvio.total} formandos.
        {reenvio.falharam.length ? ` Não foi para: ${reenvio.falharam.join(', ')}.` : ''}
      </span>
    );
  }

  atualizarTextoBotao = (resposta, btn, msgs) => {
    let text = '',
      color = '';

    if (resposta) {
      text = msgs.sucesso;
      color = '#00a65a';
    } else {
      text = msgs.erro;
      color = '#dd4b39';
    }

    btn.innerHTML = text;
    btn.style.color = color;
    btn.setAttribute('disabled', 'true');
    btn.closest('div').classList.add('animate__headShake');

    setTimeout(() => {
      btn.innerHTML = msgs.resetar;
      btn.removeAttribute('disabled');
      btn.style.color = '#1890ff';
      btn.closest('div').classList.remove('animate__headShake');
    }, 3000);
  };

  alterarFormando = (e) => {
    const { name, value } = e.target;
    this.setState({ formando: { ...this.state.formando, [name]: value } });
  };

  salvarFormando = async (e) => {
    e.preventDefault();
    let { formando } = this.state,
      button = document.querySelector(`#btnEditarFormando${formando.id}`),
      auxFormando = {
        id: formando.id,
        nome: formando.nome,
        email: formando.email,
        celular: formando.celular,
        documento: formando.documento,
        turma: formando.turma,
      };

    if (formando.usuario) {
      auxFormando.usuario = formando.usuario.id;
      await this.props.editarFormandoEUsuario(auxFormando);
      await this.carregarInfoContrato(this.state.selecionado.id);
      this.setState({ showModalFormando: false });
      this.atualizarTextoBotao(true, button, {
        sucesso: "<i class='fa fa-check'></i>",
        resetar: "<i class='fa fa-pencil'></i>",
      });
    } else {
      await this.props.editarFormando(auxFormando);
      await this.carregarInfoContrato(this.state.selecionado.id);
      this.setState({ showModalFormando: false });
      this.atualizarTextoBotao(true, button, {
        sucesso: "<i class='fa fa-check'></i>",
        resetar: "<i class='fa fa-pencil'></i>",
      });
    }
  };

  criarUsuarioFormando = async () => {
    let { formandos, gerandoLogins } = this.state;

    this.setState({ gerandoLogins: true });

    for (let i = 0; i < formandos.length; i++) {
      let formando = formandos[i];

      if (!formando.usuario) {
        await this.props.adicionarUsuarioFormando(formando);
      }
    }

    this.setState({ gerandoLogins: false });
    this.carregarInfoContrato(this.state.selecionado.id);
  };

  handleChangeCursoSelecionado(data) {
    this.setState({
      formando: {
        ...this.state.formando,
        turma: data.value,
        curso: data.label,
      },
      cursoSelecionado: data,
    });
  }

  handleChangeTurmaSelecionada(data) {
    this.setState({ turmaSelecionada: data });
  }

  async handleClickDeletarFormando(formando) {
    this.setState({ deletandoFormando: true });
    await this.props.deletarFormandoEUsuario(formando);

    const auxFormandos = this.state.formandos.filter(
      (formandoItem) => formandoItem.id !== formando.id
    );

    this.setState({
      formandos: auxFormandos,
      showModalPedidosFormando: false,
      deletandoFormando: false,
    });
  }

  handleClickCardTurmas = () => {
    let { todosOsCursos, cursosSelect } = this.state;

    if (todosOsCursos.length === 0) {
      axios
        .get(`${URL_MAPA}/cursos`, {
          headers: { Authorization: localStorage.getItem('tokenMapaVendas') },
        })
        .then((response) => {
          let aux = [];
          response.data.forEach((curso) => {
            if (
              cursosSelect.filter((c) => {
                return c.label === curso.nomecurso;
              }).length === 0
            ) {
              aux.push({ value: curso.idcurso, label: curso.nomecurso });
            }
          });
          this.setState({ showModalTurmas: true, todosOsCursos: aux });
        })
        .catch((err) => {
          this.setState({ showModalTurmas: false });
          // toast.error("Não foi possível carregar a lista de cursos. Tente novamente!");
        });
    }
    this.setState({ showModalTurmas: true });
  };

  handleClickRemoverTurma = (curso) => {
    let { cursosSelect, todosOsCursos } = this.state;

    this.props
      .removerTurma(curso.value)
      .then(() => {
        cursosSelect = cursosSelect.filter((cursoSelect) => {
          return cursoSelect.value !== curso.value;
        });
        todosOsCursos.push(curso);
        todosOsCursos = todosOsCursos.sort((a, b) => {
          return a.label > b.label ? 1 : -1;
        });
        this.setState({ cursosSelect, todosOsCursos });
      })
      .catch(() => {
        // toast.error("Não foi possível remover essa turma. Tente novamente!");
      });
  };

  handleClickEditarFormando = (formando) => {
    let button = document.querySelector(`#btnEditarFormando${formando.id}`);

    button.innerHTML = "<i class='fa fa-spinner fa-spin'></i>";

    this.setState({
      formando: formando,
      showModalFormando: true,
      cursoSelecionado: { value: formando.turma, label: formando.curso },
    });
  };

  handleClickPedidosFormando = (formando) => {
    let button = document.querySelector(`#btnPedidosFormando${formando.id}`);

    button.innerHTML = "<i class='fa fa-spinner fa-spin'></i>";
    axios
      .get(`${URL_PAGAMENTO}/administracao/formando/${formando.id}/pedidos`, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('tokenPagamento'),
        },
      })
      .then((response) => {
        this.setState({
          formando: formando,
          pedidosFormando: response.data,
          showModalPedidosFormando: true,
        });
      })
      .catch((err) => {
        alert('Não foi possível carregar a lista de pedidos. Tente novamente!');
        // toast.error("Não foi possível carregar a lista de pedidos. Tente novamente!");
      })
      .finally(() => {
        button.innerHTML = "<i class='fa fa-shopping-cart'></i>";
      });
  };

  handleSubmitAdicionarTurma = (e) => {
    e.preventDefault();

    let {
      informarNomeTurmaManual,
      turmaSelecionada,
      nomeNovaTurma,
      todosOsCursos,
    } = this.state;

    this.props
      .adicionarTurma({
        contrato: this.state.selecionado.id,
        curso: informarNomeTurmaManual ? nomeNovaTurma : turmaSelecionada.label,
      })
      .then(() => {
        let auxTodosOsCursos = todosOsCursos.filter((curso) => {
          return curso.label !== turmaSelecionada.label;
        });
        auxTodosOsCursos = auxTodosOsCursos.sort((a, b) => {
          return a.label > b.label ? 1 : -1;
        });
        this.setState({
          cursosSelect: [
            ...this.state.cursosSelect,
            {
              value: this.props.novaTurma.id,
              label: this.props.novaTurma.curso,
            },
          ],
          showSelectTurmas: false,
          informarNomeTurmaManual: false,
          nomeNovaTurma: '',
          turmaSelecionada: {},
          todosOsCursos: auxTodosOsCursos,
        });
      })
      .catch(() => {
        // toast.error("Não foi possível vincular essa turma ao contrato. Tente novamente!");
      });
  };

  handleClickFecharModalFormando = () => {
    document.querySelector(
      `#btnEditarFormando${this.state.formando.id}`
    ).innerHTML = "<i class='fa fa-pencil'></i>";
    this.setState({ showModalFormando: false, formando: {} });
  };

  changeEtapa = (valor) => {
    this.setState({ carregandoChangeEtapa: true });
    this.props
      .editarCamposContrato(this.state.selecionado.id, {
        cadastrouFormandos: valor,
      })
      .then(() => {
        this.setState({
          selecionado: { ...this.state.selecionado, cadastrouFormandos: valor },
          carregandoChangeEtapa: false,
        });
      });
  };

  _renderCadeado() {
    let cadastrouFormandos =
        this.state.selecionado &&
        this.state.selecionado.cadastrouFormandos === 1
          ? true
          : false,
      novoValor = cadastrouFormandos ? 0 : 1;
    return (
      <i
        disabled={this.state.carregandoChangeEtapa}
        className={
          this.state.carregandoChangeEtapa
            ? 'fa fa-spinner fa-spin'
            : cadastrouFormandos
            ? 'fa fa-lock'
            : 'fa fa-unlock'
        }
        onClick={() => this.changeEtapa(novoValor)}
      />
    );
  }

  _renderCards() {
    let numUsuarios = this.state.formandos.length,
      numUsuariosComAcesso = this.state.formandos.filter((f) => {
        return f.usuario;
      }).length,
      numUsuariosSemAcesso = numUsuarios - numUsuariosComAcesso;
    return (
      <div className='row'>
        <div className='col-md-6 col-lg-4'>
          <div className='small-box bg-aqua'>
            <div className='inner' style={{ minHeight: 123 }}>
              <h3>
                {numUsuariosComAcesso}/{numUsuarios}
              </h3>
              <p style={{ marginBottom: 5 }}>
                Formandos cadastrados com acesso ao sistema
              </p>
            </div>
          </div>
        </div>
        {numUsuariosSemAcesso > 0 ? (
          <div className='col-md-6 col-lg-4'>
            <div className='small-box bg-red'>
              <div className='inner' style={{ minHeight: 123 }}>
                <h3>{numUsuariosSemAcesso}</h3>
                <p style={{ marginBottom: 5 }}>
                  Formandos cadastrados sem acesso ao sistema.{' '}
                  {this.state.gerandoLogins ? (
                    <span>
                      <i className='fa fa-spinner fa-spin'></i> Gerando logins
                    </span>
                  ) : (
                    <a
                      style={{ color: 'white', textDecoration: 'underline' }}
                      onClick={() => this.criarUsuarioFormando()}
                    >
                      Clique aqui para gerar!
                    </a>
                  )}
                </p>
              </div>
            </div>
          </div>
        ) : null}
        <div className='col-md-6 col-lg-4'>
          <div className='small-box bg-yellow'>
            <div className='inner' style={{ minHeight: 123 }}>
              <h3>{this.state.cursosSelect.length}</h3>
              <p style={{ marginBottom: 5 }}>
                Turmas vinculadas a este contrato.{' '}
                <a
                  style={{ color: 'white', textDecoration: 'underline' }}
                  onClick={() => this.handleClickCardTurmas()}
                >
                  Clique aqui para gerenciar!
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const columns = [
      {
        title: 'Nome',
        key: 'nome',
        render: (record) => (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {record.nome}
            {record.usuario ? (
              <div style={{ color: '#28a745', fontSize: 10 }}>
                <i className='fa fa-check'></i> Login gerado
              </div>
            ) : (
              <div style={{ color: '#dc3545', fontSize: 10 }}>
                <i className='fa fa-times'></i> Login não gerado
              </div>
            )}
          </div>
        ),
      },
      { title: 'E-mail', dataIndex: 'email', key: 'email' },
      { title: 'Celular', dataIndex: 'celular', key: 'celular' },
      {
        title: 'CPF',
        dataIndex: 'documento',
        key: 'documento',
        render: (documento) => documento ? documento.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') : '-'
      },
      { title: 'Data de Nascimento',
        dataIndex: 'dataNascimento', 
        key: 'dataNascimento',
        render: (dataNascimento) => dataNascimento ? dataNascimento.split('-').reverse().join('/') : '-' 
      },
      { title: 'Curso', dataIndex: 'curso', key: 'curso' },
      {
        title: 'Ações',
        key: 'action',
        render: (record) => (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                color: '#1890ff',
                marginRight: 5,
                marginLeft: 5,
                cursor: 'pointer',
              }}
              className='animate__animated animate__repeat-3 3'
              id={`btnPedidosFormando${record.id}`}
              onClick={() => this.handleClickPedidosFormando(record)}
            >
              <i class='fa fa-shopping-cart'></i>
            </div>
            <div
              style={{
                color: '#1890ff',
                marginRight: 5,
                marginLeft: 5,
                cursor: 'pointer',
              }}
              className='animate__animated animate__repeat-3 3'
              id={`btnEditarFormando${record.id}`}
              onClick={() => this.handleClickEditarFormando(record)}
            >
              <i className='fa fa-pencil' />
            </div>
            {record.usuario ? (
              <div
                style={{
                  color: '#1890ff',
                  marginRight: 5,
                  marginLeft: 5,
                  cursor: 'pointer',
                }}
                className='animate__animated animate__repeat-3 3'
                id={`btnEnviarEmail${record.id}`}
                onClick={() => this.enviarEmail(record)}
              >
                <i className='fa fa-envelope' />
              </div>
            ) : null}
          </div>
        ),
      },
    ];
    return (
      <div>
        <Modal
          show={this.state.showModal}
          onHide={this.close.bind(this)}
          bsSize='large'
          dialogClassName='modal-90w'
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {this._renderCadeado()} | Formandos do contrato{' '}
              {this.state.selecionado ? this.state.selecionado.numero : ''}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this._renderCards()}
            {this.state.formandos.length > 0 ? (
              <div className='table-responsive'>
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                  {this._renderResultadoReenvio()}
                  <button
                    type='button'
                    className='btn btn-primary btn-sm'
                    disabled={this.state.reenviandoTodos || !this.state.formandos.some((f) => f.usuario)}
                    onClick={this.reenviarParaTodos}
                    title='Reenvia o e-mail de acesso para todos os formandos com login'
                  >
                    {this.state.reenviandoTodos && this.state.reenvio ? (
                      <span><i className='fa fa-spinner fa-spin' style={{ marginRight: 5 }} />Enviando {this.state.reenvio.feitos} de {this.state.reenvio.total}</span>
                    ) : (
                      <span><i className='fa fa-envelope' style={{ marginRight: 5 }} />Reenviar para todos</span>
                    )}
                  </button>
                  <ReactHTMLTableToExcel
                    className='btn btn-success btn-sm'
                    table='tabelaFormandos'
                    filename={`Formandos - Contrato ${this.state.selecionado ? this.state.selecionado.numero : ''}`}
                    sheet='Formandos'
                    buttonText={<span><i className='fa fa-download' style={{ marginRight: 5 }} />Baixar</span>}
                  />
                </div>
                <Table
                  columns={columns}
                  dataSource={this.state.formandos}
                  rowKey={(record) => record.id}
                  bordered
                />
                <div style={{ display: 'none' }}>
                  <table id='tabelaFormandos'>
                    <thead>
                      <tr>
                        <th>Nome</th>
                        <th>E-mail</th>
                        <th>Celular</th>
                        <th>CPF</th>
                        <th>Data de Nascimento</th>
                        <th>Curso</th>
                        <th>Login gerado</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.formandos.map((formando) => (
                        <tr key={formando.id}>
                          <td>{formando.nome}</td>
                          <td>{formando.email}</td>
                          <td>{formando.celular}</td>
                          <td>{formando.documento ? formando.documento.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') : '-'}</td>
                          <td>{formando.dataNascimento ? formando.dataNascimento.split('-').reverse().join('/') : '-'}</td>
                          <td>{formando.curso}</td>
                          <td>{formando.usuario ? 'Sim' : 'Não'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <h4>Ainda não existem formandos cadastrados</h4>
            )}
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.showModalFormando}
          onHide={() => this.handleClickFecharModalFormando()}
        >
          <form onChange={this.alterarFormando} onSubmit={this.salvarFormando}>
            <Modal.Header closeButton>
              <Modal.Title>Editar formando</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className='form-group'>
                <label htmlFor='nome'>
                  <span className='perguntaObrigatoria'>*</span>Nome
                </label>
                <input
                  type='text'
                  className='form-control'
                  name='nome'
                  value={this.state.formando.nome}
                  required
                  autoFocus
                />
              </div>
              <div className='form-group'>
                <label htmlFor='email'>
                  <span className='perguntaObrigatoria'>*</span>E-mail
                </label>
                <input
                  type='email'
                  className='form-control'
                  name='email'
                  value={this.state.formando.email}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="documento">CPF</label>
                <input 
                type="text" 
                className="form-control" 
                name="documento" 
                value={this.state.formando.documento || ''} placeholder="000.000.000-00"/>
              </div>
              <div className='form-group'>
                <label htmlFor='senha'>
                  <span className='perguntaObrigatoria'>*</span>Celular
                </label>
                <input
                  type='text'
                  className='form-control'
                  name='celular'
                  value={this.state.formando.celular}
                  mask='(99) 9 9999-9999'
                  required
                />
              </div>
              <div className='form-group'>
                <label htmlFor='senha'>
                  <span className='perguntaObrigatoria'>*</span>Curso
                </label>
                <Select
                  required
                  placeholder='Selecione o curso'
                  name='turma'
                  value={this.state.cursoSelecionado}
                  onChange={this.handleChangeCursoSelecionado.bind(this)}
                  options={this.state.cursosSelect}
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button
                name='salvar'
                type='submit'
                className='btn btn-primary flat'
              >
                Salvar
              </button>
            </Modal.Footer>
          </form>
        </Modal>

        <Modal
          show={this.state.showModalPedidosFormando}
          onHide={() => {
            this.setState({ showModalPedidosFormando: false, formando: {} });
          }}
          bsSize='large'
        >
          <Modal.Header closeButton>
            <Modal.Title>Pedidos do formando</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 10,
              }}
            >
              <p style={{ marginBottom: 0 }}>
                Formando: {this.state.formando.nome}
              </p>
              {this.state.pedidosFormando.length === 0 && (
                <button
                  className='btn btn-danger'
                  onClick={() =>
                    this.handleClickDeletarFormando(this.state.formando)
                  }
                  disabled={this.state.deletandoFormando}
                >
                  {this.state.deletandoFormando ? (
                    <span>
                      <i class='fa fa-spinner fa-spin'></i> Deletando formando
                    </span>
                  ) : (
                    'Deletar formando'
                  )}
                </button>
              )}
            </div>
            <TabelaPedidosFormando
              data={this.state.pedidosFormando}
              atualizarPedidosFormando={() => {
                this.handleClickPedidosFormando(this.state.formando);
              }}
            />
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.showModalTurmas}
          onHide={() => this.setState({ showModalTurmas: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Gerenciar turmas</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.showSelectTurmas ? (
              <div>
                <form onSubmit={this.handleSubmitAdicionarTurma}>
                  <div className='switch' style={{ marginRight: '10px' }}>
                    <input
                      type='checkbox'
                      id='informarNomeTurmaManual'
                      className='switch__input'
                      defaultChecked={this.state.informarNomeTurmaManual}
                      onClick={() => {
                        this.setState({
                          informarNomeTurmaManual:
                            !this.state.informarNomeTurmaManual,
                        });
                      }}
                    />
                    <label
                      htmlFor='informarNomeTurmaManual'
                      className='switch__label'
                      style={{ fontWeight: 400 }}
                    >
                      {' '}
                      Informar nome manualmente
                    </label>
                  </div>

                  {!this.state.informarNomeTurmaManual ? (
                    <div className='form-group'>
                      <label htmlFor='curso'>Selecione um curso</label>
                      <Select
                        name='curso'
                        id='curso'
                        required
                        value={this.state.turmaSelecionada}
                        onChange={this.handleChangeTurmaSelecionada.bind(this)}
                        options={this.state.todosOsCursos}
                        placeholder='Selecione'
                      />
                    </div>
                  ) : (
                    <div className='form-group'>
                      <label htmlFor='nomeTurma'>Informe o nome da turma</label>
                      <input
                        onChange={(e) => {
                          this.setState({ nomeNovaTurma: e.target.value });
                        }}
                        id='nomeTurma'
                        className='form-control'
                      />
                    </div>
                  )}

                  <button
                    className='btn btn-link'
                    onClick={() => this.setState({ showSelectTurmas: false })}
                    disabled={this.state.carregandoAdicionarTurma}
                  >
                    Cancelar
                  </button>
                  <button
                    className='btn btn-primary'
                    type='submit'
                    disabled={this.state.carregandoAdicionarTurma}
                  >
                    {this.state.carregandoAdicionarTurma ? (
                      <span style={{ display: 'flex', alignItems: 'center' }}>
                        <i
                          style={{ marginRight: 5 }}
                          className='fa fa-spinner fa-spin'
                        />{' '}
                        Carregando
                      </span>
                    ) : (
                      'Adicionar'
                    )}
                  </button>
                </form>
              </div>
            ) : (
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {this.state.cursosSelect.map((curso, i) => (
                  <div
                    key={i}
                    className='label label-default badgePersonalizada'
                    title={`${
                      this.state.formandos.filter((formando) => {
                        return formando.curso === curso.label;
                      }).length
                    } formandos vinculados a esta turma`}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      {curso.label}
                      <span style={{ fontSize: 10 }}></span>
                    </div>
                    {this.state.formandos.filter((formando) => {
                      return formando.curso === curso.label;
                    }).length === 0 ? (
                      <i
                        className='fa fa-times'
                        style={{ cursor: 'pointer', marginLeft: 5 }}
                        onClick={() => this.handleClickRemoverTurma(curso)}
                      ></i>
                    ) : null}
                  </div>
                ))}
                <div
                  style={{ cursor: 'pointer' }}
                  onClick={() => this.setState({ showSelectTurmas: true })}
                  className='label label-success badgePersonalizada'
                >
                  <i
                    className='fa fa-plus'
                    style={{ cursor: 'pointer', marginRight: 5 }}
                  ></i>{' '}
                  NOVO
                </div>
              </div>
            )}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado,
    formandos: state.formando.todos,
    carregandoFormando: state.formando.carregando,
    novaTurma: state.turmas.novaTurma,
  };
};

export default connect(
  mapStateToProps,
  {
    editarCamposContrato,
    editarFormando,
    editarFormandoEUsuario,
    deletarFormandoEUsuario,
    obterFormandosPeloContrato,
    adicionarUsuarioFormando,
    adicionarTurma,
    removerTurma,
  },
  null,
  { forwardRef: true }
)(DetalhesFormando);



// WEBPACK FOOTER //
// ./src/components/DetalhesFormando.js